// import effects here
import { provideEffects } from '@ngrx/effects';
import { IrGeneratorEffects } from '@ps/ai-assistant-data-access';
import { AUTH_STORE_PROVIDERS } from '@ps/auth-data-access';
import { SOCKET_STORE_PROVIDERS } from '@ps/core-data-access';
import { SURVEY_STORE_PROVIDERS } from '@ps/survey-data-access';
import { SURVEY_CREATION_STORE_PROVIDERS } from '@ps/survey-creation-data-access';
import { SURVEY_MANAGEMENT_STORE_PROVIDERS } from '@ps/survey-management-data-access';
import { MANAGE_SUPPLIER_STORE_PROVIDERS } from '@ps/survey-manage-supplier-data-access';
import { TEMPLATE_STORE_PROVIDERS } from '@ps/survey-template-data-access';
import { REPORT_STORE_PROVIDERS } from '@ps/report-data-access';
import { SupplierEffects } from '@ps/supplier-data-access';
import { CompanyEffects } from '@ps/company-data-access';
import {
  QuestionEffects,
  QuestionSearchEffects,
} from '@ps/question-data-access';
import { InvoiceEffects } from '@ps/invoice-data-access';
import { BuyerEffects, DecipherMappingEffects } from '@ps/buyers-data-access';
import { UserEffects } from '@ps/user-data-access';
import { USER_SETTINGS_STORE_PROVIDERS } from '@ps/user-settings-data-access';
import { TAGS_STORE_PROVIDERS } from '@ps/tags-data-access';
import { NOTIFICATION_STORE_PROVIDERS } from '@ps/notification-data-access';
import {
  CompanyMarginsEffects,
  CoreMappingsEffects,
  ExternalBuyerMappingsEffects,
  OperatorCompaniesEffects,
  OperatorSettingsCurrencyEffects,
  OperatorSettingsEffects,
} from '@ps/platform-setting-data-access';

// add effect in this export
export const STORE_EFFECTS = [
  provideEffects(IrGeneratorEffects),
  AUTH_STORE_PROVIDERS.effects,
  SOCKET_STORE_PROVIDERS.effects,
  SURVEY_STORE_PROVIDERS.effects,
  SURVEY_CREATION_STORE_PROVIDERS.effects,
  SURVEY_MANAGEMENT_STORE_PROVIDERS.effects,
  MANAGE_SUPPLIER_STORE_PROVIDERS.effects,
  TEMPLATE_STORE_PROVIDERS.effects,
  REPORT_STORE_PROVIDERS.effects,
  provideEffects(CompanyEffects),
  provideEffects(QuestionEffects),
  provideEffects(QuestionSearchEffects),
  provideEffects(InvoiceEffects),
  provideEffects(SupplierEffects),
  provideEffects(BuyerEffects),
  provideEffects(DecipherMappingEffects),
  provideEffects(UserEffects),
  provideEffects(OperatorSettingsEffects),
  provideEffects(OperatorSettingsCurrencyEffects),
  provideEffects(ExternalBuyerMappingsEffects),
  provideEffects(CoreMappingsEffects),
  provideEffects(CompanyMarginsEffects),
  provideEffects(OperatorCompaniesEffects),
  USER_SETTINGS_STORE_PROVIDERS.effects,
  TAGS_STORE_PROVIDERS.effects,
  NOTIFICATION_STORE_PROVIDERS.effects,
];
